import {EventEmitter, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {Contract, Tender} from '../../models';

@Injectable()
export class TenderBidSubmitService {

    constructor(private http: HttpClient) {
    }

    public submit(tender: Tender, contract: Contract, offerId: number, body: {} = {}) {
        let url = `${environment.apiUrl}/v2/buyer/tenders/${tender.id}/contracts/${contract.id}/offer/${offerId}/submit/`;
        return this.http.post(url, body)
    }

    public createNextOffer(tender: Tender, contract: Contract, currentOfferId: number, body: {} = {}) {
        let url = `${environment.apiUrl}/v2/buyer/tenders/${tender.id}/contracts/${contract.id}/offer/${currentOfferId}/create-next-offer/`;
        return this.http.post(url, body)
    }
}
